var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24.854 17.316l7.045 6.52c.067.112.101.234.101.358 0 .442-.427.8-.954.8h-5.903v9.042c0 .529-.512.957-1.143.957-.586 0-1.07-.37-1.135-.846l-.008-.111v-9.042h-5.902c-.1 0-.197-.013-.29-.038l-.137-.047c-.472-.197-.663-.678-.427-1.072l7.045-6.521a.893.893 0 01.427-.358c.472-.197 1.045-.037 1.28.358zM35.547 13a1.453 1.453 0 110 2.905H12.453a1.453 1.453 0 010-2.905h23.094z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
